import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { Button, LinearProgress } from '@mui/material'
import { lessonScheduleApiSlice } from '../../../../../features/schedule/lessonScheduleSlice'
import { H3 } from '../../../../../layouts/TextStyles'
import UploadLinksTable from './components/UploadLinksTable'
import { UploadLinkState } from '../../../../../features/types'
import { useParams } from 'react-router-dom'
import AddUploadLinkDialog from './components/AddUploadLinkDialog'

import BaseBreadcrumb from '../../../../../components/Breadcrumb'
import { ui } from '../../../../../utils/uiTokens'

const LessonDetailsPage = () => {
    const { lessonId } = useParams()
    const { formatMessage } = useIntl()
    const [dialogOpen, setDialogOpen] = useState(false)

    const { data: uploadLinksData = [], isFetching } = lessonScheduleApiSlice.useFetchUploadLinksQuery(Number(lessonId))
    const [deleteUploadLink, { isLoading: isDeleting }] = lessonScheduleApiSlice.useDeleteUploadLinkMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteUploadLink({ lessonId: Number(lessonId), id: Number(id) }).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {
            toast.error(formatMessage({ id: 'deleteFail' }))
        }
    }

    const handleOpenDialog = (uploadLink?: UploadLinkState) => {
        setDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setDialogOpen(false)
    }

    return (
        <Wrapper>
            <BaseBreadcrumb links={[formatMessage({ id: 'schedule' }), formatMessage({ id: 'lessonLinks' })]} />
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'lessonLinks' })}</H3>
                    </Title>
                    <Button variant="contained" onClick={() => handleOpenDialog()}>
                        {formatMessage({ id: 'add' })}
                    </Button>
                </Header>

                {isFetching || isDeleting ? (
                    <LinearProgress />
                ) : null}

                <UploadLinksTable
                    uploadLinksData={uploadLinksData || []}
                    onDelete={handleDelete}
                />

                <AddUploadLinkDialog
                    open={dialogOpen}
                    handleClose={handleCloseDialog}
                />
            </Content>
        </Wrapper>
    )
}

export default LessonDetailsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
